export const colorPickerPlaceholderColor = '#FFFFFF';
